// src/routesConfig.js
import React, { lazy } from 'react';
import GeneralSettings from './Pages/settings/General';
import NotFoundPage from './Pages/404-page'; // Import the NotFoundPage
import Terms from './Pages/terms an condition/terms';
import PrivacyPolicy from './Pages/privacy-policy/PrivacyPolicy';
import { createBrowserRouter, Outlet, ScrollRestoration } from 'react-router-dom';
import { getUser } from './redux/user/userReducer';
import SocketProvider from './provider/SocketProvider';
import { albumDetailLoader, getPostLoader, getPublicRouteUser, getReelLoader, groupProfileLoader, naray8ChapterLoader, naray8StoryLoader, naray8UploadStoryLoader, naray8WriterLoader, userProfileLoader } from './routerLoaders';
import Navbar from './Components/Navbar';
import ErrorPage from './ErrorPage';
import { useSelector } from 'react-redux';
import CategoryPage from './Pages/Naray8/CategoryPage';
import StoryDetail from './Components/Naray8/StoryDetail';
import StoryDetailPage from './Pages/Naray8/StoryPage';
import ChapterPage from './Pages/Naray8/ChapterPage';
import WalletPage from './Pages/wallet';
import PostPage from './Pages/PostPage';
import WalletCoin from './Pages/wallet/WalletCoin';
import Wallet from './Pages/wallet/Wallet';
import { setRouterInstance } from './routerInstance';


//profile
const TimelineProfile = lazy(() => import('./Components/ProfilePage/Timeline'));
const RightSideFriend = lazy(() => import('./Components/FindfriendPage/RightSideFriend'));
const EventRender = lazy(() => import('./Components/ProfilePage/EventSection'));
const AlbumSection = lazy(() => import('./Components/ProfilePage/Albums'));
const GroupRender = lazy(() => import('./Components/ProfilePage/my-group-profile'));
const ReelsSection = lazy(() => import('./Components/ProfilePage/Reels'))


//user-profile
const UserPosts = lazy(() => import("./Pages/userProfileScreen/UserPosts"))
const UserFriends = lazy(() => import("./Pages/userProfileScreen/UserFriends"))
const UserAlbums = lazy(() => import("./Pages/userProfileScreen/UserAlbums"))
const UserReels = lazy(() => import("./Pages/userProfileScreen/UserReels"))



const Login = lazy(() => import('./Components/Login'));
const Register = lazy(() => import('./Components/Register'));
const Forgot = lazy(() => import('./Components/Forgot'));
const Homepage = lazy(() => import('./Pages/Homepage'));
const Feed = lazy(() => import('./Pages/Feed'));
const Naray8 = lazy(() => import('./Pages/Naray8'));
const Naray8Discover = lazy(() => import('./Pages/Naray8/Discover'));
const Naray8Writer = lazy(() => import('./Pages/Naray8/Writer'));
const Naray8Upload = lazy(() => import('./Pages/Naray8/Naray8Upload'));
// const Pro = lazy(() => import('./Pages/Pro'));
const Profile = lazy(() => import('./Pages/Profile'));
// const Uploadpage = lazy(() => import('./Pages/Uploadpage'));
// const FriendPage = lazy(() => import('./Pages/FriendPage'));
const ViewGroup = lazy(() => import('./Pages/ViewGroup'));
const Chat = lazy(() => import('./Pages/Chat/Chat'));
const VerifyOTP = lazy(() => import('./Pages/Verify/VerifyOTP'));
const PasswordReset = lazy(() => import('./Pages/Verify/Reset'));
const UserProfile = lazy(() => import('./Pages/userProfile/userProfile'));
const ViewStories = lazy(() => import('./Components/viewStories/viewStories'));
const PhotoStory = lazy(() => import('./Pages/story/photoStory'));
const TextStory = lazy(() => import('./Pages/story/textStory'));
const TextPost = lazy(() => import('./Pages/postModule/textPost'));
const ViewPost = lazy(() => import('./Components/view-post/viewPost'));
const RealsPage = lazy(() => import('./Components/realsModule/reals-page/reals-page'));
const ViewUserReals = lazy(() => import('./Components/realsModule/view-reals/view-user-reals'));
const GroupModule = lazy(() => import('./Pages/group-section'));
const EventsModule = lazy(() => import('./Pages/EventsModule/events-section'));
const ViewEvents = lazy(() => import('./Pages/events-page/events'));
const FriendListSidenav = lazy(() => import('./Pages/Findfriend/FListSidenav'));
const AlbumModule = lazy(() => import('./Pages/Albulm/Albumpage'));
const AlbumContent = lazy(() => import('./Pages/Albulm/AlbumContent'));
const SavePostModule = lazy(() => import('./Pages/savePost/save-post'));
const LandingPage = lazy(() => import('./Pages/landing-page/landingpage'));
const Notifications = lazy(() => import('./Pages/Notifications'));



const App = () => {
  const { userData } = useSelector(state => state.user)

  return userData.userId ? (
    <div className='w-full min-h-screen pt-16 bg-black'>
      <SocketProvider>
        <ScrollRestoration />
        <Navbar />
        <div className='max-w-screen-2xl mx-auto min-h-[calc(100vh-64px)] bg-customDark' >
          <Outlet />
        </div>
      </SocketProvider >
    </div>
  ) : <LandingPage />
}

const publicRoutes = [
  { path: "/login", element: <Login />, errorElement: <ErrorPage />, loader: getPublicRouteUser },
  { path: "/register", element: <Register />, errorElement: <ErrorPage />, loader: getPublicRouteUser },
  { path: "/forgot", element: <Forgot />, errorElement: <ErrorPage />, loader: getPublicRouteUser },
  { path: "/Verify/:email", element: <VerifyOTP />, errorElement: <ErrorPage />, loader: getPublicRouteUser },
  { path: "/Reset/:email/:otp", element: <PasswordReset />, errorElement: <ErrorPage />, loader: getPublicRouteUser },
  { path: "/terms", element: <Terms />, errorElement: <ErrorPage /> },
  { path: "/privacy-policy", element: <PrivacyPolicy />, errorElement: <ErrorPage /> }
];

// List of protected routes (requires authentication)
const protectedRoutes = [
  {
    path: "/profile",
    element: <Profile />,
    children: [
      { path: "", element: <TimelineProfile /> },
      { path: 'friends', element: <RightSideFriend /> },
      { path: 'albums', element: <AlbumSection /> },
      { path: 'groups', element: <GroupRender /> },
      { path: 'events', element: <EventRender /> },
      { path: 'reels', element: <ReelsSection /> },
    ]
  },
  { path: "/group", element: <GroupModule /> },
  { path: "/notifications", element: <Notifications /> },
  { path: "/group/:groupId", element: <ViewGroup />, loader: groupProfileLoader },
  { path: "/friends", element: <FriendListSidenav /> },
  { path: "/album", element: <AlbumModule /> },
  { path: "/album/:albumId", element: <AlbumContent />, loader: albumDetailLoader },
  { path: "/events", element: <EventsModule /> },
  { path: "/events/:eventId", element: <ViewEvents /> },
  { path: "/savepost", element: <SavePostModule /> },
  { path: "/Chat", element: <Chat />, errorElement: <ErrorPage /> },
  {
    path: "/user/:userId",
    element: <UserProfile />,
    loader: userProfileLoader,
    children: [
      { path: "", element: <UserPosts /> },
      { path: "friends", element: <UserFriends /> },
      { path: "albums", element: <UserAlbums /> },
      { path: "reels", element: <UserReels /> }
    ]
  },
  { path: "/stories", element: <ViewStories /> },
  { path: "/create-text-story", element: <TextStory /> },
  { path: "/create-photo-story", element: <PhotoStory /> },
  { path: "/create-post", element: <TextPost /> },
  { path: "/view-post/:postId", element: <ViewPost /> },
  { path: "/flips/:postId?", element: <RealsPage />, loader: getReelLoader },
  { path: "/watch-flips", element: <ViewUserReals /> },
  { path: "/setting", element: <GeneralSettings /> },
  {
    path: "/write-naray8/:storyId?",
    element: <Naray8Upload />,
    loader: naray8UploadStoryLoader
  },
  { path: "/story/:storyId", element: <StoryDetail /> },
  { path: "/story/:storyId/chapter/:chapterId", element: <StoryDetail /> }
];

// Combine both public and protected routes
const router = createBrowserRouter([
  ...publicRoutes,
  {
    path: "/",
    element: <App />,
    loader: getUser,
    children: [
      {
        path: "", element: <Homepage />, children: [
          { path: "", element: <Feed /> },
          { path: "post/:postId", element: <PostPage />, loader: getPostLoader },
          {
            path: "/naray8",
            element: <Naray8 />,
            children: [
              { path: "", element: <Naray8Discover /> },
              { path: "writer/:writerId", element: <Naray8Writer />, loader: naray8WriterLoader },
              { path: ":slug", element: <CategoryPage /> },
              { path: "b/:narrateId", element: <StoryDetailPage />, loader: naray8StoryLoader },
              { path: "b/:narrateId/chapter/:chapterId", element: <ChapterPage />, loader: naray8ChapterLoader },
            ]
          },
          {
            path: "/wallet",
            element: <WalletPage />,
            children: [
              { path: "", element: <Wallet /> },
              { path: "bd-coins", element: <WalletCoin /> }
            ]
          }
        ]
      }, // homepage as default if logged in
      // all your protectedRoutes here
      ...protectedRoutes.map(route => ({
        ...route,
        path: route.path.replace(/^\//, ""),
      })),
    ],
    errorElement: <ErrorPage />
  },
  { path: "*", element: <NotFoundPage /> },
]);

// Let non-component code (the axios interceptor) trigger real navigation on
// a 401 - see routerInstance.js.
setRouterInstance(router);

export default router;
